import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
} from '@angular/core';

import { Subscription } from 'rxjs';
import { ResultpageService } from '../../../service/resultpage.service';
import { OffersOfApplication } from '../../../type/result_type';
import { OfferType } from '../../../type/offer_type';
import { Router } from '@angular/router';
import { ResultpagesharedService } from '../../../service/resultpageshared.service';
import { NavigationService } from '../../../service/navigation.service';
import { BreakpointService } from '../../../service/breakpoint.service';
import { closingtrackUrl } from '../../../../utils/url';
import { currencyFormatter } from '../../../../utils/currencyFormatter';
import { isAllowedCheck24ImagesHost } from '../../../../config/check24-environment';

@Component({
  selector: 'app-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent implements OnInit, OnDestroy {
  @ViewChild('dialogContent') dialogContent!: TemplateRef<any>;
  @ViewChild('dialogActions') dialogActions!: TemplateRef<any>;
  @ViewChild('kreditdetailsBtn') kreditdetailsBtn!: ElementRef;
  @Input() cardData!: OffersOfApplication;
  @Input() twoApplicants!: boolean;
  @Input() offersType!: string;
  @Input() resultPage!: boolean;
  @Input() eternalPage!: boolean;
  @Input() closeDetail!: boolean;
  @Input() inSlider!: boolean;
  @Input() sliderWrapper!: boolean;
  @Input() pageType?: string;
  @ViewChildren('tabButton') tabButtons!: QueryList<ElementRef>;

  private offersSubscription: Subscription;

  private createdOffers: boolean = false;
  public activated!: number;
  public popup!: OfferType['popup'];
  public openDetails: boolean = false;
  public openCustomerRatings: boolean = false;
  public showDurationOffer: boolean = false;
  public durationModification: any = null;
  public offers: any = {};
  private durationOffer: number = 30;
  public leftDays!: number;
  private _logo: string;
  private defaultBank: string =
    '/resultpage/assets/img/offerBox/default_bank.svg';
  public paybackImg!: string;
  private payback500: string = '/resultpage/assets/img/offerBox/payback500.png';
  public showDefaultBank: boolean = false;
  public possiblePayback!: boolean;
  public interestExplanationHintText =
    'Der Zweidrittelzins dient der Vergleichbarkeit von Krediten mit bonitätsabhängiger Verzinsung. Die Bank gewährt mindestens zwei von drei angenommenen Kunden den Kredit zu diesem Zweidrittelzinssatz oder zu einem günstigeren Zinssatz.';
  public interestCalculationText = '';
  public showGoodBadInterests = false;
  public goodMonthlyInstallment: number;
  public badMonthlyInstallment: number;
  public showInterestExplanation = false;
  public showInterestExplanationItems = [
    'PRELIMINARY_OFFER',
    'EXPIRED',
    'DOCUMENTS_UPLOADED',
    'DOCUMENTS_MISSING',
    'DOCUMENTS_CHECKED',
    'REJECTED_CLEARING',
    'REJECTED',
    'DOCUMENTS_MISSING_2ND',
    'DOCUMENTS_CHECKED_2ND',
    'DOCUMENTS_UPLOADED_2ND',
    'REJECTED_2ND',
    'NEW',
  ];

  windowCouponAmount: string;
  windowCouponLabel: string;

  constructor(
    private resultpageService: ResultpageService,
    private sharedResultService: ResultpagesharedService,
    private breakpointService: BreakpointService,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  get windowSize() {
    return this.breakpointService.windowSize;
  }

  ngOnInit(): void {
    this.logoMobile = this.cardData?.bankProduct?.bankDetails?.logoUrl || '';
    this.possiblePayback = window['wf_cpid'] === 'ch24at_payback';
    this.windowCouponAmount = window['wf_sso_coupon_amount'];
    this.windowCouponLabel = window['wf_sso_coupon_label'];
    this.paybackImg =
      this.cardData.paybackBasicPoints && this.cardData.paybackBasicPoints > 0
        ? this.cardData.paybackImageUrl
          ? this.cardData.paybackImageUrl
          : this.cardData.paybackBasicPoints === 500
          ? this.payback500
          : ''
        : '';
    //---calculate days and if there are less than 10 days until the expiration date, we will show a message---
    function datediff(first, second) {
      return Math.round((first - second) / (1000 * 60 * 60 * 24));
    }
    const currentDate = new Date();
    const offerDate = new Date(this.cardData.createdAt);
    let days = datediff(currentDate, offerDate);
    this.leftDays = this.durationOffer - days;
    this.showDurationOffer = this.leftDays <= 10;
    this.durationModification = this.getDurationModification();
    //---calculate days and if there are less than 10 days until the expiration date, we will show a message---

    this.getLocalData();
    if (this.offersType !== 'noOffersOfApplication') this.setCalculatedData();
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    if (this.createdOffers) {
      this.offersSubscription.unsubscribe();
    }
  }

  openCreditDetails(id): void {
    this.openDetails = !this.openDetails;
    // Close customer ratings if it's open
    if (this.openDetails && this.openCustomerRatings) {
      this.openCustomerRatings = false;
    }
    if (this.openDetails) {
      this.offers[this.offersType] = {
        ...this.offers[this.offersType],
        [id]: { details: 0 },
      };
      setTimeout(() => {
        if (this.tabButtons && this.tabButtons.first) {
          this.tabButtons.first.nativeElement.focus();
        }
      });
    } else {
      delete this.offers[this.offersType][id];
    }
    this.resultpageService.updatedCards(this.offers);
  }

  toggleCustomerRatings(id: any): void {
    this.openCustomerRatings = !this.openCustomerRatings;
    if (this.openCustomerRatings && this.openDetails) {
      this.openDetails = false;
    }
    if (this.openCustomerRatings) {
      // When opening customer ratings, set only customerRatings flag (remove details if present)
      this.offers[this.offersType] = {
        ...this.offers[this.offersType],
        [id]: { customerRatings: true },
      };
    } else {
      if (this.offers[this.offersType] && this.offers[this.offersType][id]) {
        delete this.offers[this.offersType][id].customerRatings;
        // Clean up the entire entry if it's empty
        if (Object.keys(this.offers[this.offersType][id]).length === 0) {
          delete this.offers[this.offersType][id];
        }
      }
    }
    this.resultpageService.updatedCards(this.offers);
  }

  get hasCustomerRatings(): boolean {
    const productId =
      this.cardData?.bankProduct?.product?.productDetails?.productId;
    return productId
      ? this.sharedResultService.hasCustomerRatings(productId)
      : false;
  }

  get customerRatingsData(): {
    averageRate: number;
    totalRaters: number;
  } | null {
    const productId =
      this.cardData?.bankProduct?.product?.productDetails?.productId;
    return productId
      ? this.sharedResultService.getCustomerRatingsData(productId)
      : null;
  }

  onDialogKeydown(event: KeyboardEvent): void {
    // Handle Enter and Space key activation for accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openCreditDetails(this.cardData.id);
    }
  }

  onCustomerRatingsKeydown(event: KeyboardEvent): void {
    // Handle Enter and Space key activation for accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleCustomerRatings(this.cardData.id);
    }
  }

  public formatDurationLabel(value?: string): string {
    if (!value) {
      return '-';
    }

    const periodMatch = value.match(/^P(\d+)M$/);
    if (periodMatch) {
      const months = Number(periodMatch[1]);
      return `${months} ${months === 1 ? 'Monat' : 'Monate'}`;
    }

    const numericValue = Number(value);
    if (!Number.isNaN(numericValue)) {
      return `${numericValue} ${numericValue === 1 ? 'Monat' : 'Monate'}`;
    }

    return value;
  }

  public get durationModificationHintData(): { title: string; text: string }[] {
    if (!this.durationModification) {
      return [];
    }

    return [
      {
        title: 'Laufzeit angepasst',
        text:
          `Ausgewählt: ${this.formatDurationLabel(this.durationModification.loanChange?.oldDuration)}` +
          `<br>Neu: ${this.formatDurationLabel(this.durationModification.loanChange?.newDuration)}` +
          `<br>Grund: ${this.durationModification.loanChange?.reason || "Da die ausgewählte Laufzeit nicht verfügbar war, haben wir die Laufzeit automatisch angepasst."}`,
      },
    ];
  }

  private getDurationModification(): any | null {
    return (
      this.cardData?.modifications?.find(
        (modification: any) =>
          modification?.loanChange?.oldDuration &&
          modification?.loanChange?.newDuration,
      ) || null
    );
  }

  openOfferDetailsMobile(id) {
    if (this.windowSize !== 'mobile') {
      return;
    }

    this.navigationService.saveScrollPosition();
    this.router.navigate(['/offer', id], {
      state: this.pageType === 'active' ? { pageType: 'active' } : undefined,
    });
  }

  private getLocalData(): void {
    this.offersSubscription = this.resultpageService.offersObserv$.subscribe(
      (data) => {
        this.createdOffers = true;
        if (data !== 1) {
          this.offers = data;
          if (
            this.offers[this.offersType] &&
            this.offers[this.offersType][this.cardData.id]
          ) {
            // Restore openDetails state
            if (
              this.offers[this.offersType][this.cardData.id].details !==
              undefined
            ) {
              this.openDetails = true;
              this.activated =
                this.offers[this.offersType][this.cardData.id].details;
            }
            // Restore openCustomerRatings state
            if (
              this.offers[this.offersType][this.cardData.id].customerRatings
            ) {
              this.openCustomerRatings = true;
            }
          }
          if (
            this.offers[this.offersType] &&
            this.offers[this.offersType].popup
          ) {
            this.popup = this.offers[this.offersType].popup;
          }
        }
      },
    );
  }

  private toPercentage(rate: number) {
    const percentage = rate * 100;
    return (
      percentage.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + '%'
    );
  }

  private setCalculatedData() {
    const interestDetails =
      this.cardData?.bankProduct?.product?.productDetails?.interestDetails;
    const terms = this.cardData?.offerResponse?.terms;

    this.showGoodBadInterests = interestDetails?.interestExplanation ?? false;
    this.goodMonthlyInstallment = terms?.goodMonthlyInstallment;
    this.badMonthlyInstallment = terms?.badMonthlyInstallment;

    const interestCalculation = interestDetails?.interestCalculation;
    if (interestCalculation) {
      this.interestCalculationText = interestCalculation
        .replace(
          '{{effective.Interest}}',
          this.toPercentage(interestDetails.effectiveInterest),
        )
        .replace(
          '{{nominal.Interest}}',
          this.toPercentage(interestDetails.nominalInterest),
        )
        .replace('{{mtl.rate}}', terms?.monthlyInstallment?.toString() ?? '')
        .replace('{{loan.amount}}', terms?.loanTotalAmount?.toString() ?? '');
    } else {
      this.interestCalculationText = '';
    }

    this.showInterestExplanation = this.showInterestExplanationItems.includes(
      this.cardData?.contractState,
    );
    if (
      !this.sharedResultService.showMobInterestExplanation.some(
        (el) => el.id === this.cardData.id,
      )
    ) {
      this.sharedResultService.showMobInterestExplanation = [
        ...this.sharedResultService.showMobInterestExplanation,
        {
          id: this.cardData.id,
          showMobInterestExplanation:
            this.showInterestExplanation &&
            this.interestCalculationText.length > 0,
        },
      ];
    }
  }

  public set logoMobile(value: any) {
    let img;
    let checkUrl = this.isValidHttpUrl(value);
    if (checkUrl) {
      let url = value.substring(0, value.lastIndexOf('/') + 1);
      let cutImg = value
        .substring(value.lastIndexOf('/') + 1, value.length)
        .split('.');
      let nameImg = cutImg[0];
      let typeImg = cutImg[1];
      img =
        typeImg !== 'svg' &&
        (nameImg.indexOf('_lowers') !== -1 ||
          nameImg.indexOf('_highres') !== -1)
          ? url + nameImg + '_lowers.' + typeImg
          : value;
    } else {
      img = this.defaultBank;
      this.showDefaultBank = true;
    }
    this._logo = img;
  }

  public get logoMobile() {
    return this._logo;
  }

  public get logoMobileHighres() {
    return this._logo;
  }

  private isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      isAllowedCheck24ImagesHost(url.hostname)
    );
  }

  switchDetails(element, id): void {
    this.activated = element;
    this.offers[this.offersType][id].details = element;
    this.resultpageService.updatedCards(this.offers);
  }

  popupToggle(value, id, name): void {
    if (value) {
      this.offers[this.offersType] = {
        ...this.offers[this.offersType],
        popup: { [name]: id },
      };
    } else {
      if (id === this.offers[this.offersType].popup[name])
        delete this.offers[this.offersType].popup[name];
    }
    this.resultpageService.updatedCards(this.offers);
  }

  onClosingTrack(tocken: string, loanAmount: number): void {
    window.location.href = closingtrackUrl(
      tocken,
      loanAmount,
      this.cardData.contractStateFlow,
    );
  }

  currencyFormatter = currencyFormatter;

  onTabKeydown(event: KeyboardEvent, index: number, id: any): void {
    const tabCount = 3;
    let newIndex = index;

    // If Shift+Tab is pressed on any tab, move focus to Kreditdetails button
    if (event.key === 'Tab' && event.shiftKey) {
      event.preventDefault();
      if (this.kreditdetailsBtn) {
        this.kreditdetailsBtn.nativeElement.focus();
      }
      return;
    }

    switch (event.key) {
      case 'ArrowRight':
      case 'Right':
        newIndex = (index + 1) % tabCount;
        break;
      case 'ArrowLeft':
      case 'Left':
        newIndex = (index - 1 + tabCount) % tabCount;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = tabCount - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.switchDetails(newIndex, id);
    // Use @ViewChildren to focus the correct tab
    const tabButtonsArr = this.tabButtons.toArray();
    if (tabButtonsArr[newIndex]) {
      tabButtonsArr[newIndex].nativeElement.focus();
    }
  }

  // Returns the aria-labelledby string for the loan details section for accessibility
  getLoanAriaLabelledBy(): string {
    let ids = `loanSubtext-${this.cardData.id} loanSubtextTitle-${this.cardData.id}`;
    if (this.twoApplicants) {
      ids += ` loanTitle-${this.cardData.id}`;
    }
    return ids;
  }

  public focusTabByIndex(tabIndex: number) {
    if (this.tabButtons && this.tabButtons.toArray()[tabIndex]) {
      this.tabButtons.toArray()[tabIndex].nativeElement.focus();
    }
  }

  trackByBullet(index: number, bullet: { name?: string; flag?: string }) {
    return `${bullet?.flag ?? ''}-${bullet?.name ?? ''}-${index}`;
  }
}
